// src/components/generics/AdminRoute.jsx
import React, { useEffect, useState } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axiosInstance from "../../utils/AxiosInstance";
import { clearAuth } from "../../utils/authStorage";
import { loginUser } from "../../redux/actions/userActions";

const buildUser = (data) => ({
  id: data?.id,
  name: data?.name,
  email: data?.email,
  type: data?.type,
  account: data?.account,
  credits: data?.account?.credit,
  buyDrawActiveMegaMillions: data?.buyDrawActiveMegaMillions,
  buyDrawActivePowerBall: data?.buyDrawActivePowerBall,
  impersonating: data?.impersonating === true,
});

const notifyAuthChanged = (authenticated, user = null) => {
  window.dispatchEvent(
    new CustomEvent("auth:changed", {
      detail: { authenticated, source: "admin-route", user },
    })
  );
};

const AdminRoute = ({ element }) => {
  const dispatch = useDispatch();
  const [isAuthorized, setIsAuthorized] = useState(null);

  useEffect(() => {
    let mounted = true;

    const checkAdmin = async () => {
      try {
        const res = await axiosInstance.get("/site/user/logged-user");
        const user = buildUser(res?.data);

        if (!user.id) {
          throw new Error("No logged user returned.");
        }

        dispatch(loginUser(user));
        notifyAuthChanged(true, user);

        if (mounted) {
          setIsAuthorized(["ADMIN", "SUPPORT"].includes(user.type));
        }
      } catch {
        clearAuth();
        notifyAuthChanged(false);

        if (mounted) {
          setIsAuthorized(false);
        }
      }
    };

    checkAdmin();

    return () => {
      mounted = false;
    };
  }, [dispatch]);

  if (isAuthorized === null) {
    return null;
  }

  return isAuthorized ? element : <Navigate to="/login" replace />;
};

export default AdminRoute;
